import React from 'react';
import NewQuejaWizard from './_Wizard.js';
import QuejaWizardProvider from 'context/QuejaWizardProvider.js';

const NewQueja = () => {
  return (
    <QuejaWizardProvider>
      <NewQuejaWizard></NewQuejaWizard>
    </QuejaWizardProvider>
  );
};

export default NewQueja;
